import React from 'react'
import Select from 'react-select'
import style from './explore-network.module.scss'
import H1 from '../Headings/H1';

const DEFAULT_VISIBLE = 3;
export default function ExploreNetworkHeader({ selectedDropdown, setSelectedDropdown, dropdownOptions, setItemVisible, title, filterLabel }) {

  const changeFilter = (e) => {
    sessionStorage.setItem("networkCategory",e.value);
    setSelectedDropdown(e);
    sessionStorage.setItem("loadMoreCount",DEFAULT_VISIBLE)
    setItemVisible(DEFAULT_VISIBLE)
  }

  return (
    <div className="flex md:justify-between flex-col md:flex-row">
      {title &&<H1 className="italic font-['Heroic-Medium']">{title}</H1>}
      <div className="flex md:items-center flex-col md:flex-row mt-4 md:mt-0">
        <p className="mb-0.5 md:mb-0">{filterLabel}</p>
        <Select
          options={dropdownOptions}
          isSearchable={false}
          className={`react-select-container md:ml-2.5 md:w-36 ${style.dropdown}`}
          classNamePrefix="react-select"
          onChange={changeFilter}
          value={selectedDropdown}
        />
      </div>
    </div>
  )
}
